import SignClient from '@walletconnect/sign-client'
import {SessionTypes} from '@walletconnect/types'
import {WalletPlatform} from '@/enums/WalletPlatform'
import {NetworkType} from '@/libs/wallet-connect-sdk-core/types'

export type WalletConnectProviderContext = {
  type: 'walletconnect'
  session: SessionTypes.Struct
  signClient: SignClient
  network: NetworkType
  walletImplementation: 'n3' | 'neoX'
  walletPlatform: WalletPlatform
}

export const isWalletConnectProvider = (
  provider: unknown
): provider is WalletConnectProviderContext =>
  typeof provider === 'object' &&
  provider !== null &&
  (provider as WalletConnectProviderContext).type === 'walletconnect'
